import React, { useState } from "react";
import { CategoriesIcon } from "../../../assets/img/CategoriesIcon";
import { CollectionDefaultValue } from "../../../defalult/CollectionDefaultValue";
import {
  CategoriesFilterValue,
  FilterWrapper,
  MarketplaceFilterButton,
  MarketplaceFilterCol,
  MarketplaceFilterDropdownCategories,
  MarketplaceFilterDropdownCollection,
  MarketplaceFilterSearch,
} from "./MarketplaceFilter.styled";

const categories = ["All", "Аrt", "Memes", "Music", "Photogаphy", "Virtuаl worlds"];

export const CategoriesFilter = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [active, setActive] = useState("All");
  return (
    <FilterWrapper
      onMouseLeave={() => {
        setShowDropdown(false);
      }}>
      <MarketplaceFilterButton
        onMouseEnter={() => {
          setShowDropdown(true);
        }}>
        {CategoriesIcon()} Categories
      </MarketplaceFilterButton>
      <MarketplaceFilterDropdownCategories showDropdown={showDropdown}>
        {categories.map((category, i) => (
          <CategoriesFilterValue
            active={category === active && true}
            onClick={() => {
              setActive(category);
            }}
            key={i}>
            {category}
          </CategoriesFilterValue>
        ))}
      </MarketplaceFilterDropdownCategories>
    </FilterWrapper>
  );
};
